import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class BrowserInfoService {
  smSmanagerHealth;

  constructor(private httpClient: HttpClient) {
  }
}
